<template>
  <div class="newship">
    <h4 class="title">
      新建发货通知单
    </h4>
    <div class="card" v-for="(item, index) in Lines">
      <el-form :inline="true" :model="item.ruleForm" ref="item.ruleForm" :rules="item.rules"  class="applybox">
        <el-form-item label="物流类型" prop="ShipmentMethod">
          <el-select class="form-input" v-model="item.ruleForm.ShipmentMethod" placeholder="请选择物流类型">
            <el-option
              v-for="item in LogisticsType"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="配送类型" prop="deliverytype" v-if="item.ruleForm.ShipmentMethod != 'none'">
          <el-select v-model="item.ruleForm.deliverytype"  placeholder="请选择配送类型">
            <el-option
              v-for="item in deliverytypes"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="配送方式" prop="facilityId" v-if="item.ruleForm.ShipmentMethod == 'internal'">
          <el-select v-model="item.ruleForm.facilityId"  placeholder="请选择配送类型">
            <el-option
              v-for="item in LogisticsFacility"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系人姓名" prop="ContactName">
          <el-input class="form-input" v-model="item.ruleForm.ContactName" placeholder="联系人姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系人电话" prop="ContactPhone">
          <el-input class="form-input" v-model="item.ruleForm.ContactPhone" placeholder="联系人电话"></el-input>
        </el-form-item>
        <br>
        <el-form-item label="配送至网点" v-if="item.ruleForm.ShipmentMethod === 'internal'" type="flex" justify="space-between">
          <el-radio v-model="item.ruleForm.ShipToPointOfSales" :label="true">是</el-radio>
          <el-radio v-model="item.ruleForm.ShipToPointOfSales" :label="false">否</el-radio>
        </el-form-item>
        <el-form-item label="联系地址" type="flex" justify="space-between" style="width: 600px">
          <address-box
            :province-id.sync="item.ruleForm.ProvinceId"
            :city-id.sync="item.ruleForm.CityId"
            :county-id.sync="item.ruleForm.CountyId"
            :point-id.sync="item.ruleForm.PointOfSalesId"
            :address.sync="item.ruleForm.StreetAddress"
            :show-point="item.ruleForm.ShipmentMethod === 'internal' && item.ruleForm.ShipToPointOfSales"
          ></address-box>
        </el-form-item>
      </el-form>
      <div class="item-box" v-for="(data, index) in item.tableData">
        <table>
          <thead>
            <tr>
              <td width="260">物料名称-编码</td>
              <td width="100">品项</td>
              <td width="80">品牌</td>
              <td width="140">机型</td>
              <td width="100">模块</td>
              <td width="100">库存来源</td>
              <td width="80">库存数量</td>
              <td>发货数量</td>
            </tr>
          </thead>
          <tbody>
            <tr >
              <td>
                {{data.ProductName}}<br>物料编码： {{data.ProductCode}}
              </td>
              <td>
                <el-tag :type="data.ConditionName | ConditionColor">{{data.ConditionName}}</el-tag>
              </td>
              <td>
                {{data.ProductBrandName}}
              </td>
              <td>
                {{data.ProductModelName}}
              </td>
              <td>
                {{data.ProductModuleName}}
              </td>
              <td>
                {{data.type | InventorySource}}
              </td>
              <td>
                {{data.Quantity}}
              </td>
              <td>
                <el-input placeholder="数量" v-model.number="data.number" @change="notOutpace(data)"></el-input>
              </td>
            </tr>
          </tbody>
        </table>
        <el-button class="delete-btn" @click.native="deleteItem(index, data, item)">X</el-button>
      </div>
      <el-button type="primary" @click.native="addMariter(item, index)">添加物料</el-button>
    </div>
    <div class="btn-box">
      <el-button type="primary" @click.native="addAddress()">新增地址</el-button>
      <div class="pull-right">
        客户订单号
        <input type="text" placeholder="客户订单号" v-model="ReferenceCode">
      </div>
      <div class="sumbit_box">
        <el-button @click.native="cancel">取消</el-button>
        <el-button type="primary" @click.native="sumbit">提交并等待客服联系</el-button>
      </div>

    </div>
    <el-dialog title="发货物料"  size="large" class="pop-box" v-model="ShipFormVisible">
      <div class="review-table">
        <el-form  :inline="true">
          <el-form-item label="物料名称">
            <el-input type="textarea" class="form-input" v-model="sendForm.ProductName" placeholder="物料名称"></el-input>
          </el-form-item>
          <el-form-item label="物料编码">
            <el-input type="textarea" class="form-input" v-model="sendForm.ProductCode" placeholder="物料编码"></el-input>
          </el-form-item>
          <el-form-item label="品项">
            <el-select v-model="sendForm.ConditionName"  placeholder="请选择品项">
              <el-option
                v-for="item in ProductConditions"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="库存来源">
            <el-select v-model="sendForm.inventorySource"  placeholder="库存来源">
              <el-option
                v-for="item in InventorySources"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"   style="margin:0 30px;" @click.native="handleSearch()">查询</el-button>
          </el-form-item>
        </el-form>
        <h5>查询结果</h5>
        <el-table
          :data="appointlist"
          ref="multipleTable"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="40">
          </el-table-column>
          <el-table-column
            label="物料名称"
            width="260">
            <template scope="prop">
              <el-col>{{prop.row.ProductName}}</el-col>
            </template>
          </el-table-column>
          <el-table-column
            label="物料编码">
            <template scope="prop">
              {{prop.row.ProductCode}}
            </template>
          </el-table-column>
          <el-table-column
            label="品项">
            <template scope="prop">
              <el-tag :type="prop.row.ConditionName | ConditionColor">{{prop.row.ConditionName}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="品牌">
            <template scope="prop">
              {{prop.row.ProductBrandName}}
            </template>
          </el-table-column>
          <el-table-column
            label="机型">
            <template scope="prop">
              {{prop.row.ProductModelName}}
            </template>
          </el-table-column>
          <el-table-column
            label="模块"
            width="120">
            <template scope="prop">
              {{prop.row.ProductModuleName}}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="text-right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ShipFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="sureAdd()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AddressBox from '@/components/common/Address'
import o from '@/odata'
import { Loading } from 'element-ui'
export default {
  data() {
    return {
      Lines: [
        {
          ruleForm: {
            ShipmentMethod: null,
            deliverytype: null,
            facilityId: null,
            ContactName: null,
            ContactPhone: null,
            ShipToPointOfSales: true,
            ProvinceId: null,
            CityId: null,
            CountyId: null,
            StreetAddress: null,
            PointOfSalesId: null,
            DeliveryManId: null,
          },
          rules: {
            // ShipmentMethod: [{required: true, message: '必填'}],
            // deliverytype: [{required: true, message: '必填'}],
            ShipmentMethod: [{required: true, message: '必填'}],
            facilityId: [{required: true, message: '必填'}],
            ContactName: [{required: true, message: '必填'}],
            ContactPhone: [{required: true, message: '必填'}],
          },
          tableData: [],
        },
      ],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      ProductConditions: [],
      LogisticsFacility: [],
      LogisticsType: [
        {label: '森普瑞物流', value: 'internal'},
        {label: '第三方物流', value: 'external'},
        {label: '自提', value: 'none'},
      ],
      activename: 'all',
      RepairType: '',
      ShipFormVisible: false,
      typename: 'all',
      warehouseDate: '',
      batchSelection: [],
      Deliverys: [
        {label: '即时配送', value: 'rental'},
        {label: '预约配送', value: 'delegated'},
      ],
      InventorySources: [
        {label: '自己代管', value: 'manage'},
        {label: '委托库存', value: 'delegate'},
        {label: '租赁代管', value: 'rent'},
      ],
      deliverytypes: [
        {label: '即时发货', value: 'immediately'},
        {label: '预约发货', value: 'scheduled'},
      ],
      sendForm: {
        ProductName: null,
        ProductCode: null,
        ConditionName: null,
        inventorySource: null,
      },
      appointlist: [],
      sumbitbox: [],
      shipbox: [],
      addItem: null,
      addIndex: null,
      ReferenceCode: null,
      LotIDs: [],
    }
  },
  created() {
    this.initship()
    this.initProductCondition()
    this.initFacility()
  },
  methods: {
    notOutpace: function(data) {
      if (data.number > data.Quantity) {
        this.$message({
          type: 'warning',
          message: '发货数量不能超过库存数量!',
        })
      }
    },
    deleteItem: function(index, data, item) {
      this.$confirm('是否确认删除?', '删除物料', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        item.tableData.splice(index, 1)
        this.shipbox.splice(index, 1)
        window.localStorage.setItem('shipbox', JSON.stringify(this.shipbox))
        this.$message({
          type: 'success',
          message: '删除成功!',
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        })
      })
    },
    sumbit: function() {
      // this.$refs['ruleForm'].validate((valid) => {
      //   if (valid) {
      let putpaceBox = []
      for (var a = 0; a < this.Lines.length; a++) {
        this.LotIDs = []
        for (var b = 0; b < this.Lines[a].tableData.length; b++) {
          if (this.Lines[a].tableData[b].number > this.Lines[a].tableData[b].Quantity) {
            putpaceBox.push(this.Lines[a].tableData[b].number)
          }
          this.sumbitbox.push({
            AddressOrder: a,
            ShipmentMethod: this.Lines[a].ruleForm.ShipmentMethod,
            DeliveryType: this.Lines[a].ruleForm.deliverytype,
            FacilityId: this.Lines[a].ruleForm.facilityId,
            ContactName: this.Lines[a].ruleForm.ContactName,
            ContactPhone: this.Lines[a].ruleForm.ContactPhone,
            ShipToPointOfSales: this.Lines[a].ruleForm.ShipToPointOfSales,
            ProvinceId: this.Lines[a].ruleForm.ProvinceId,
            CityId: this.Lines[a].ruleForm.CityId,
            CountyId: this.Lines[a].ruleForm.CountyId,
            StreetAddress: this.Lines[a].ruleForm.StreetAddress,
            PointOfSalesId: this.Lines[a].ruleForm.PointOfSalesId,
            ProductId: this.Lines[a].tableData[b].ProductId,
            Quantity: this.Lines[a].tableData[b].number,
            ConditionId: this.Lines[a].tableData[b].ConditionId,
            Type: this.Lines[a].tableData[b].type,
          })
        }
        // this.sumbitbox.push({
        //   Notes: null,
        //   Lots: this.LotIDs,
        // })
      }
      const Invoice = o('ShipmentRequest')
      const form = {
        Lines: this.sumbitbox,
        ReferenceCode: this.ReferenceCode,
      }
      if (putpaceBox.length > 0) {
        this.$message({
          type: 'warning',
          message: '发货数量不能超过库存数量!',
        })
      } else {
        let loading = Loading.service({text: '正在提交订单,请稍后', customClass: 'comfirmLoading'})
        Invoice.post(form).save().then((response) => {
          this.$message({
            message: '提交成功',
            type: 'success',
          })
          loading.close()
          this.shipbox = []
          window.localStorage.setItem('shipbox', JSON.stringify(this.shipbox))
          // this.$router.push('/managed')
          this.$router.push('/leaseSent_order')
        }).catch((response) => {})
      }
      //   }
      // })
    },
    cancel: function() {
      // 根据跳转之前的页面,跳转回对应的页面
      const newshipFlag = window.localStorage.getItem('newshipFlag')
      if (newshipFlag === 'trustListPage') {
        // 跳转至委托库查询-自己委托库
        window.localStorage.setItem('trustListFlag', 'self')
        window.localStorage.setItem('newshipFlag', '')
        this.$router.push('/trust')
      } else {
        // 跳转至代管库查询-自有代管库
        window.localStorage.setItem('orderUrl', 'entrustOrder')
        this.$router.push('/managed')
      }
    },
    addMariter: function(item, index) {
      this.addItem = ''
      this.addIndex = ''
      this.ShipFormVisible = true
      this.addItem = item
      this.addIndex = index
      this.sendForm.inventorySource = 'delegate'
    },
    sureAdd: function() {
      let warehouseType = this.sendForm.inventorySource
      for (var a = 0; a < this.batchSelection.length; a++) {
        this.Lines[this.addIndex].tableData.push({
          Id: this.batchSelection[a].Id,
          ProductCode: this.batchSelection[a].ProductCode,
          ProductName: this.batchSelection[a].ProductName,
          ProductBrandName: this.batchSelection[a].ProductBrandName,
          ConditionName: this.batchSelection[a].ConditionName,
          ProductModelName: this.batchSelection[a].ProductModelName,
          ProductModuleName: this.batchSelection[a].ProductModuleName,
          Quantity: this.batchSelection[a].Quantity,
          inventorySource: null,
          type: warehouseType,
          number: 1,
          ProductId: this.batchSelection[a].ProductId,
          ConditionId: this.batchSelection[a].ConditionId,
        })
      }
      this.ShipFormVisible = false
    },
    handleSearch: function() {
      let loading = Loading.service({text: '正在提交订单,请稍后', customClass: 'comfirmLoading'})
      let Customer = ''
      if (this.sendForm.inventorySource === 'delegate') {
        Customer = o('CustomerDelegatedProductQuantity?isCustomerRelated=true')
      } else if (this.sendForm.inventorySource === 'rent') {
        Customer = o('CustomerManagedProductQuantity?lotType=rental')
      } else {
        Customer = o('CustomerManagedProductQuantity?lotType=private')
      }
      let filters = []
      if (this.sendForm.ProductName) {
        filters.push(`contains(ProductName, '${this.sendForm.ProductName}')`)
      }
      if (this.sendForm.ProductCode) {
        filters.push(`contains(ProductCode, '${this.sendForm.ProductCode}')`)
      }
      if (this.sendForm.ConditionName) {
        filters.push(`(ConditionId eq ${this.sendForm.ConditionName})`)
      }
      if (filters.length > 0) {
        Customer.filter(filters.join(' and '))
      }
      Customer.inlineCount()
      Customer.skip((this.currentPage - 1) * this.pageSize)
      Customer.top(this.pageSize)
      Customer.get().then(({data, inlinecount}) => {
        this.appointlist = data
        this.total = inlinecount
        loading.close()
      }).catch(() => {
        loading.close()
      })
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
    handleCurrentChange(page) {
      this.currentPage = page
      this.handleSearch()
    },
    addAddress: function() {
      this.Lines.push({
        ruleForm: {
          ShipmentMethod: null,
          deliverytype: null,
          ContactName: null,
          ContactPhone: null,
          ShipToPointOfSales: true,
          ProvinceId: null,
          CityId: null,
          CountyId: null,
          StreetAddress: null,
          PointOfSalesId: null,
          DeliveryManId: null,
        },
        rules: {
          ShipmentMethod: [{required: true, message: '必填'}],
          facilityId: [{required: true, message: '必填'}],
          ContactName: [{required: true, message: '必填'}],
          ContactPhone: [{required: true, message: '必填'}],
        },
        tableData: [],
      })
    },
    initship: function() {
      this.shipbox = JSON.parse(window.localStorage.getItem('shipbox'))
      console.log(this.shipbox)
      for (var a = 0; a < this.shipbox.length; a++) {
        this.Lines[0].tableData.push({
          Id: this.shipbox[a].Id,
          ProductCode: this.shipbox[a].ProductCode,
          ProductName: this.shipbox[a].ProductName,
          ProductBrandName: this.shipbox[a].ProductBrandName,
          ConditionName: this.shipbox[a].ConditionName,
          ProductModelName: this.shipbox[a].ProductModelName,
          ProductModuleName: this.shipbox[a].ProductModuleName,
          type: this.shipbox[a].type,
          Quantity: this.shipbox[a].Quantity,
          inventorySource: null,
          number: 1,
          ProductId: this.shipbox[a].ProductId,
          ConditionId: this.shipbox[a].ConditionId,
        })
      }
    },
    handleSelectionChange: function(selection) {
      this.batchSelection = selection
    },
    initProductCondition: function() {
      const Inventory = o('ProductCondition')
      Inventory.get().then((data) => {
        this.ProductConditions = data.data
      }).catch((data) => {})
    },
    initFacility: function() {
      o('LogisticsFacility').get()
      .then((response) => {
        this.LogisticsFacility = response.data
      }).catch((err) => {
        console.log(err)
      })
    },
  },
  components: {
    AddressBox,
  },
}
</script>

<style lang="less">
.newship{
  h4.title{
    font-size: 26px;
    color: #86939E;
    letter-spacing: 0;
    margin-bottom: 20px;
    margin-top: 0;
  }
  .card {
    background: #fff;
    border-radius: 4px 4px 6px 6px;
    border-top: 5px solid #808080;
    box-sizing: border-box;
    position: relative;
    padding: 10px;
    margin-bottom: 20px;
  }
  .btn-box{
    input{
      font-size: 14px;
      color: #86939E;
      letter-spacing: 0;
      line-height: 14px;
      padding:2px 10px;
      margin-left: 5px;
    }
  }
  .item-box{
    position: relative;
    padding: 20px;
    background-color: #fff;
    margin-bottom: 25px;
    border: 1px solid #E1E8EE;
    width: 90%;
    .el-select,.el-input{
      width: 100%;
    }
    .delete-btn{
      position: absolute;
      right: -60px;
      top: 35%;
      background-color: #FF4949;
      color: #fff;
      padding: 10px 12px;
      border-radius: 50%;
      border: none;
    }
    table{
      display: inline-block;
      label{
        display: block;
        margin-bottom: 5px;
      }
      td{
        padding-right: 20px;
      }
      td:last-child{
        padding-right: 0;
      }
    }
  }
  .applybox{
    margin-bottom: 20px;
    .el-form--inline .el-form-item__content{
      display: block !important;
    }
    .el-form-item{
      position: relative;
      .el-form-item__label{
        padding-left: 0px;
      }
      .el-form-item__content span.dot{
        position: absolute;
        top: -35px;
        font-size: 16px;
        left: 0;
        color: red;
      }
    }
  }
  .el-form--inline .el-form-item__content{
    display: block;
  }
  .pop-box{
    .el-dialog__title{
      font-size: 24px;
      margin-bottom: 20px;
      color: #354052;
    }
    .el-form--inline .el-form-item__content{
      display: inline-block;
    }
  }
  .sumbit_box{
    text-align: right;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// NewShipPage.vue?5fcaf56f